import FormField from "./FormField";

export default class FormSection {
    public id: string = "";
    public title: string = "";
    public subText: string = "";

    public fields: FormField[] = [];
}